import { createWebHistory, createRouter } from "vue-router"
import HomeView from "@/views/HomeView.vue"
import AdminView from "@/views/AdminView.vue"
import PortfolioView from "@/views/PortfolioView.vue"
import ProjectSummary from "@/components/mydata/ProjectSummary.vue"
import CompSearchDetailsPage from "@/components/comp-search-details/CompSearchDetailsPage.vue"
import NewProjectPage from "@/components/add-project/NewProjectPage.vue"
import ProjectConfirmationView from "@/views/ProjectConfirmationView.vue"
import UploadDocumentsView from "@/components/upload-documents/UploadDocumentsView.vue"
import DrawTemplateSetup from "@/components/DrawTemplateSetup.vue"
import ReportPage from "@/components/comp-search-details/ReportPage.vue"
import OrganizationManagement from "@/components/auth/OrganizationManagement.vue"
import DocumentReviewView from "@/views/DocumentReviewView.vue"
import DocumentClassificationView from "@/views/DocumentClassificationView.vue"
import TemplateLibraryView from "@/views/TemplateLibraryView.vue"
import DocumentViewer from "@/views/DocumentViewer.vue"
import ProjectDocumentsView from "@/views/ProjectDocumentsView.vue"
import CompanyProfileView from "@/views/CompanyProfileView.vue"
import DirectoryView from "@/views/DirectoryView.vue"
import NotificationDetailView from "@/views/NotificationDetailView.vue"

const routes = [
  {
    path: "/",
    redirect: "/portfolio"
  },
  {
    path: "/compsearch",
    children: [
      {
        path: "",
        name: "Home",
        component: HomeView
      },
      {
        path: ":selectedTab",
        name: "Comp Search Details",
        component: CompSearchDetailsPage,
      },
    ]
  },
  {
    path: "/admin",
    name: "Admin",
    component: AdminView,
    meta: { title: '' }
  },
  {
    path: "/portfolio",
    children: [
      {
        path: '',
        name: 'Portfolio',
        component: PortfolioView
      },
      // Will be the main page of all Budget, Schedule, Companies and DOcuments.
      {
        path: "project-summary/:selectedId",
        name: "Project Summary Page",
        component: ProjectSummary
      }
    ]
  },
  {
    path: "/project",
    name: "New Project",
    component: NewProjectPage
  },
  {
    path: "/project-confirmation",
    name: "Project Confirmation",
    component: ProjectConfirmationView
  },
  {
    path: "/upload-documents",
    name: "Upload Documents",
    component: UploadDocumentsView
  },
  {
    path: "/reports",
    name: "Report Details",
    component: ReportPage,
  },
  {
    path: "/organization",
    name: "Organization Management",
    component: OrganizationManagement,
    meta: { requiresAuth: true }
  },
  {
    path: "/document-review/:id",
    name: "Document Review",
    component: DocumentReviewView,
    meta: { requiresAuth: true }
  },
  {
    path: "/document-classification/:id",
    name: "Document Classification",
    component: DocumentClassificationView,
    meta: { requiresAuth: true }
  },
  {
    path: "/template-library",
    name: "Template Library",
    component: TemplateLibraryView,
    meta: { requiresAuth: true }
  },
  {
    path: "/draw-template-setup/:templateId",
    name: "Draw Template Setup",
    component: DrawTemplateSetup,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/document-viewer/:id",
    name: "Document Viewer",
    component: DocumentViewer,
    meta: { requiresAuth: true }
  },
  {
    path: "/projects/:id/documents",
    name: "Project Documents List",
    component: ProjectDocumentsView,
    meta: { requiresAuth: true }
  },
  {
    path: "/companies/:type/:id",
    name: "Company Profile",
    component: CompanyProfileView,
    meta: { requiresAuth: true },
    props: true
  },
  {
    path: "/directory",
    name: "Directory",
    component: DirectoryView,
    meta: { requiresAuth: true }
  },
  {
    path: "/notifications/:id",
    name: "Notification Detail",
    component: NotificationDetailView,
    meta: { requiresAuth: true }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router